import PropTypes from "prop-types";
import React from "react";
import { Button } from "reactstrap";
import { ButtonOnExporting } from "../../utils/DataGridExporter";

/**
 * ExportButton - Verileri Excel formatında dışa aktarmak için kullanılan buton komponenti
 * 
 * Bu komponent, tablo veya benzer veri yapılarını Excel formatında dışa aktarmak için
 * kullanılır. Excel simgeli yeşil bir buton sunar ve tıklandığında verileri indirilebilir
 * Excel dosyası olarak kullanıcıya sunar.
 * 
 * Varsayılan davranış olarak, ButtonOnExporting fonksiyonunu çağırarak referans verilen 
 * içeriği Excel dosyasına dönüştürür. İstenirse özel bir onClick fonksiyonu ile 
 * farklı bir dışa aktarma işlemi gerçekleştirilebilir.
 *
 * @param {Object} props
 * @param {Function} props.onClick - İsteğe bağlı özel tıklama işlevi. Eğer tanımlanırsa, 
 *                                  varsayılan dışa aktarma işlemi yerine bu fonksiyon çalıştırılır.
 * @param {Object} props.refValue - Dışa aktarılacak veri yapısının referansı (örn. tablo, grid vb.)
 *                                 Bu değer ButtonOnExporting fonksiyonuna aktarılır.
 * @param {string} props.title - Oluşturulacak Excel dosyasının başlığı (varsayılan: "Export")
 * @param {string} props.sheetName - Excel içindeki çalışma sayfasının adı (varsayılan: "Sayfa-1")
 */
const ExportButton = ({ onClick, refValue, title = "Export", sheetName = "Sayfa-1" }) => {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e); // Özel tıklama işlevi varsa onu çalıştır
        } else {
            ButtonOnExporting(e, refValue, title, sheetName); // Varsayılan Excel dışa aktarma işlemini gerçekleştir
        }
    };

    return (
        <Button
            color="success"
            style={{ paddingInline: "10px", color: "white" }}
            onClick={handleClick}
        >
            <i className="fa fa-file-excel-o" />
        </Button>
    );
};

ExportButton.propTypes = {
    onClick: PropTypes.func,
    refValue: PropTypes.object.isRequired,
    title: PropTypes.string,
    sheetName: PropTypes.string
};

export default ExportButton;